import { Button, Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "@cmde/shadcn";
import { NetworkIcon, RotateCwIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

export function ErrorOrganizationsList({
  retry,
  errorMessage,
}: {
  retry: () => void;
  errorMessage?: string;
}) {
  const { t } = useTranslation();

  return (
    <Empty className="border border-solid bg-white/30">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <NetworkIcon />
        </EmptyMedia>
        <EmptyTitle>{t("organizations.list.general.error_fetching_organizations")}</EmptyTitle>
        <EmptyDescription>
          {errorMessage ?? t("organizations.list.general.error_description")}
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button onClick={retry}>
          <RotateCwIcon />
          {t("organizations.list.general.retry")}
        </Button>
      </EmptyContent>
    </Empty>
  );
}
